<app-search-form [event]="event" (searchRequested)="onSearchRequested($event)" (tabChanged)="onTabChange($event)" (clearSearchResults)="clearPreviousResults()"></app-search-form>

<ng-container *ngIf="userSelected">
    <div class="mt-4 mb-5">
        <h6 class="card-header-label" style="padding-left: 1em;">Dati Cliente</h6>
        <app-policy-card [item]="userSelected" [title]="getUserName(userSelected)"
            [keys]="getSubjectKeys(userSelected)" [tooltip]="'Contraente'">
        </app-policy-card>
    </div>
</ng-container>

<ng-container *ngIf="polizze && polizze.length > 0; else noPoliciesBlock">
    <div class="mt-4 pb-5">
        <div class="card-header-box">
            <h6 class="card-header-label">Polizze associate al Cliente</h6>
            <div>
                <ng-container *ngFor="let filter of policyTypesFilter">
                    <span class="badge filter-badge mx-1" [ngClass]="filter?.currentStyle"
                        (click)="onPolicyTypeFilterClick(filter)">
                        {{ filter?.label }}
                    </span>
                </ng-container>
            </div>
        </div>
        <ng-container *ngFor="let item of filteredPolicies">
            <app-policy-card [item]="item" [title]="item?.policyId" [keys]="policyKeys" [showLogo]="true"
                [showBadge]="true" [showArrow]="showArrow(item)" [tooltip]="'Numero polizza BPER'" (actionRequested)="onPolicySelected($event)">
            </app-policy-card>
        </ng-container>
    </div>
</ng-container>
<ng-template #noPoliciesBlock>
    <ng-container *ngIf="!notYetSearched && !isAdvancedSearch">
        <div class="mt-4 d-flex text-center flex-column align-items-center">
            <mat-icon class="no-results-icon" aria-hidden="false" aria-label="no-documents-icon"
                fontIcon="file_copy_off"></mat-icon>
            <h4 class="no-docs-text" *ngIf="showAccreditamentoMessage; else noPoliciesFoundText">{{ policiesAccreditamentoWarnMessage }}</h4>
            <ng-template #noPoliciesFoundText>
                <h4 class="no-docs-text">Nessun risultato trovato</h4>
            </ng-template>
        </div>
    </ng-container>
</ng-template>

<div class="mt-4 pb-5" *ngIf="anagrafiche && anagrafiche.length > 0; else noSubjectsBlock">
    <div class="d-flex justify-content-between align-items-center">
        <h6 class="card-header-label">Risultati di ricerca</h6>
        <div class="d-flex flex-column justify-content-end">
            <div class="card-disclaimer-label" *ngIf="showResultsMessage">{{ anagraficheWarnMessage }}</div>
            <div class="card-disclaimer-label" *ngIf="showAccreditamentoMessage">{{ subjectsAccreditamentoWarnMessage }}</div>
        </div>
    </div>
    <ng-container *ngFor="let item of anagrafiche">
        <app-policy-card [item]="item" [title]="getUserName(item)" [keys]="getSubjectKeys(item)" [showArrow]="true" [tooltip]="'Contraente'"
            (actionRequested)="onSubjectSelected($event)">
        </app-policy-card>
    </ng-container>
</div>
<ng-template #noSubjectsBlock>
    <ng-container *ngIf="!notYetSearched && isAdvancedSearch">
        <div class="mt-4 d-flex text-center flex-column align-items-center">
            <mat-icon class="no-results-icon" aria-hidden="false" aria-label="no-subjects-icon"
                fontIcon="no_accounts"></mat-icon>
            <h4 class="no-docs-text">Nessun soggetto trovato</h4>
        </div>
    </ng-container>
</ng-template>